import { Menu, SvgIcon } from '@mui/material'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import AngleRightIcon from '@hapana/shared/web/styles/assets/svgs/angle-right.svg'
import IconFileGraph from '@hapana/shared/web/styles/assets/svgs/file-graph.svg'
import PlusIcon from '@hapana/shared/web/styles/assets/svgs/plus-small.svg'
import Button from '../button/button.component'
import { BUTTON_VARIANTS } from '../button/button.constants'

import { styles } from './custom-navigation-item.styles'

const MENU_ID = 'positioned-menu'
const I_FRAME = 'I_FRAME'

const CustomNavigationItem = ({ isOpen, items, addNewLinkAction, shouldShowAddAdminLink }) => {
  const { t } = useTranslation(['common'])

  const [anchorEl, setAnchorEl] = React.useState(null)
  const newLinkButtonRef = useRef()
  const [windowUrl, setWindowUrl] = useState('')
  const isAnchorOpen = Boolean(anchorEl)
  const handleClickCustomItem = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseCustomItem = () => {
    setAnchorEl(null)
    setWindowUrl('')
  }

  const handleClickOnLink = (item) => {
    if (item?.openingMethod !== I_FRAME) {
      item.onClick || window.open(item.url, '_blank', 'noopener')
    } else {
      setWindowUrl(item?.url)
    }
  }

  const handleAddNewLink = () => {
    newLinkButtonRef.current.blur()
    addNewLinkAction()
  }

  return (
    <>
      <ListItemButton
        sx={[styles.customItemButton, isOpen && styles.openedCustomItemButton]}
        id={`${MENU_ID}`}
        aria-controls={isAnchorOpen ? MENU_ID : undefined}
        aria-haspopup="true"
        aria-expanded={isAnchorOpen ? 'true' : undefined}
        onClick={handleClickCustomItem}
      >
        <ListItemIcon sx={styles.itemIcon}>
          <SvgIcon sx={styles.menuIcon} component={IconFileGraph} />
        </ListItemIcon>
        {!isOpen && (
          <ListItemIcon sx={styles.itemIcon}>
            <SvgIcon sx={styles.angleRightIcon} component={AngleRightIcon} />
          </ListItemIcon>
        )}
      </ListItemButton>
      <Menu
        id={MENU_ID}
        aria-labelledby={MENU_ID}
        anchorEl={anchorEl}
        open={isAnchorOpen}
        onClose={handleCloseCustomItem}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={styles.menu}
      >
        <Box sx={styles.menuItemContainer}>
          <Box sx={styles.customPageLabelContainer}>
            <Typography sx={styles.customPageLabel}>
              {t('common:navigationLinks.customPage', { count: 2 })}
            </Typography>
          </Box>
          {items?.map((item, index) => (
            <ListItemButton
              key={item.id || item.customAdminLinkId || `custom-nav-item-${index}`}
              sx={[styles.itemButton]}
              onClick={() => handleClickOnLink(item)}
            >
              <ListItemIcon sx={styles.itemIcon}>
                <SvgIcon sx={styles.menuIcon} component={item.icon} />
              </ListItemIcon>
              <ListItemText primary={item.label} sx={styles.itemLabel} />
            </ListItemButton>
          ))}
        </Box>
        {shouldShowAddAdminLink && <Divider sx={styles.divider} />}
        <Box sx={styles.buttonContainer}>
          {shouldShowAddAdminLink && (
            <Button
              variant={BUTTON_VARIANTS.TEXT}
              startIcon={PlusIcon}
              label={t('common:navigationLinks.addNewLink')}
              onClick={handleAddNewLink}
              ref={newLinkButtonRef}
            />
          )}
        </Box>
        {windowUrl && (
          <Box sx={styles.iFrameContainerStyles}>
            <iframe title="Embedded Content" src={windowUrl} style={styles.iFrameStyles} />
          </Box>
        )}
      </Menu>
    </>
  )
}

CustomNavigationItem.propTypes = {
  isOpen: PropTypes.bool,
  items: PropTypes.array,
  addNewLinkAction: PropTypes.func,
  shouldShowAddAdminLink: PropTypes.bool,
}

export default CustomNavigationItem
